import { render, staticRenderFns } from "./afterSaleWaitConfirmRouter.vue?vue&type=template&id=4c351101&scoped=true&"
import script from "./afterSaleWaitConfirmRouter.vue?vue&type=script&lang=js&"
export * from "./afterSaleWaitConfirmRouter.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleWaitConfirmRouter.vue?vue&type=style&index=0&id=4c351101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c351101",
  null
  
)

export default component.exports